module.exports = __webpack_public_path__ + "img/c-3.3d082218.jpg";